import { Panel } from 'escrowbuild-ui';

import { useT } from '@/i18n';

export function OpportunitiesPage() {
  const t = useT();

  return (
    <Panel title={t('opportunities.title')} description={t('opportunities.scaffold')}>
      <p className="text-sm text-body">{t('opportunities.placeholder')}</p>
    </Panel>
  );
}
